// extracted by mini-css-extract-plugin
module.exports = {"picker":"custom-color-picker_picker_3e2_S","button":"custom-color-picker_button_3q_qw"};